import * as Sentry from '@sentry/react';

const dsn = (process.env.REACT_APP_SENTRY_DSN || '').trim();
export const SENTRY_ENABLED = Boolean(dsn);

if (SENTRY_ENABLED) {
  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'production',
    release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || '0.10'),
    tracePropagationTargets: [/^\//, new RegExp(`^${(process.env.REACT_APP_BACKEND_URL || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}/api`)],
    sendDefaultPii: false,
  });
}

export { Sentry };
